export default __webpack_public_path__ + "static/media/BluePokeball.73fd8eec.svg";